import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { HisDateUtils } from '../../../core/utils';
import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';

// Explicitly define dateFormat because his-calendar-directive does
// not reformat a value set by form control.
@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
            <p-calendar #content
                [hisDdKey]="options.ddKey"
                [formControl]="formControl"
                [dateFormat]="dateFormat"
                appendTo="body" >
            </p-calendar>
	    </his-plam>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class DateComponent extends HisDynamicFieldBase<Date> implements OnInit {
    private hbgs: HisBaseGlobalsService;

    options: HisDynamicFieldConfig;
    dateFormat: string;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.hbgs = hbgs;

        this.options = injectedData.options;
    }

    ngOnInit(): void {
        this.dateFormat = HisDateUtils.languageToDateFormatsMap.get( this.hbgs.getLanguage() );
        if( this.options.defaultValue ) {
            this.value = new Date( this.options.defaultValue );
        }
        // console.log('this.value: ', this.value);
        super.initFormControl( this.value );
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        if ( matchingConfig !== null ) {
            let newValue = matchingConfig.defaultValue;
            this.formControl.setValue( newValue, { emitEvent: false } );
        }
    }

    getControlValue(): any {
        return this.formControl.value ?
            HisDateUtils.formatEnglishDateFromString( new Date( this.formControl.value ) ) : '';
    }

}
